import React from 'react';

import ReceptorSuggestionsList from '../../../receptores/suggestions/ReceptorSuggestionsList';

class ReceptorSuggestions extends React.Component {

  handleOnSelect = (item) => {
    this.props.onSelect(item);
  }

  render() {
    const { autoFocus, data = {} } = this.props;

    return (
      <>
        { !data.Nacional && !data.Extranjero && (
            <div>
              <ReceptorSuggestionsList
                autoFocus={ autoFocus }
                onSelect={ this.handleOnSelect }
              />
            </div>
          )
        }
      </>
    );
  }
}

export default ReceptorSuggestions;